import { AccessorsMutatorsDecorator, Model } from '../../helpers';

/**
 * @class DemoRequest
 */
export class DemoRequest extends Model {

    static get REFERENCE_TYPE() {

        return {
            'current_client': 'CURRENT_CLIENT',
            'search_engine': 'SEARCH_ENGINE',
            'recommended': 'RECOMMENDED_BY_CURRENT_CUSTOMER',
            'advertisement': 'ADVERTISEMENT',
            'social_media': 'SOCIAL_MEDIA',
            'others': 'OTHERS',
        };
    }
    
    toObject(...keys) {
        
        const object = angular.copy(super.toObject(...keys));
        
        if (object['property_type']) {
            
            object['property_type_id'] = object['property_type'].id;
            delete object.property_type;
        }
        
        if (object['country']) {
            
            object['country_id'] = object['country'].id;
            delete object.country;
        }
        
        return object;
    }
}

AccessorsMutatorsDecorator(
    'property_name',
    'property_type',
    'first_name',
    'last_name',
    'email',
    'phone_code',
    'phone_number',
    'country',
    'rooms_count',
    'reference_type',
    'referred_by'
)(DemoRequest);



// WEBPACK FOOTER //
// ./src/pms-api/models/demo-request.model.js